import {BidState} from '../../../types/Bids'
import sharedLabel from '../../../translation'
import type {ILabel} from '../../../../../types'

export default {
    ...sharedLabel,
    articleVariation: <ILabel>{
        de: 'Variante:',
        en: 'Variation:',
        es: 'Variante:',
        fr: 'Variante:',
        nl: 'Variant:',
        it: 'Variante:',
    },
    bidPrice: <ILabel>{
        de: 'Ihr Gebot',
        en: 'Your bid price:',
        es: 'Precio pujado:',
        fr: 'Prix enchère:',
        nl: 'Uw bod:',
        it: 'La sua offerta:',
    },
    finalPrice: <ILabel>{
        de: 'Ihr Preis:',
        en: 'Your price:',
        es: 'Su precio:',
        fr: 'Votre prix:',
        nl: 'Uw prijs:',
        it: 'Il suo prezzo:',
    },
    bidStatus: (state: BidState, isAgentBid: boolean): ILabel => {
        if(isAgentBid) {
            if(state === BidState.pending) {
                return {
                    de: 'Gebot wird geprüft',
                    en: 'Your bid is being verified...',
                    es: 'Su puja será verificada.',
                    fr: 'Votre enchère sera vérifiée...',
                    nl: 'Uw bod wordt gecontroleerd...',
                    it: 'La Sua offerta verrá verificata; si prega di attendere',
                }
            }
            if(state === BidState.confirmed) {
                return sharedLabel.bidSuccessful
            }
            if(state === BidState.denied) {
                return {
                    de: 'Gebot abgelehnt',
                    en: 'Bid rejected',
                    es: 'Puja rechazada',
                    fr: 'Offre rejetée',
                    nl: 'Bod afgewezen',
                    it: 'Offerta rifiutata',
                }
            }
        } else {
            if(state === BidState.pending) {
                return {
                    de: 'Buchung wird geprüft',
                    en: 'Your booking is being verified...',
                    es: 'Su reservar será verificada.',
                    fr: 'Votre réservation sera vérifiée...',
                    nl: 'Uw boeking wordt gecontroleerd...',
                    it: 'Prenotazione è controllata',
                }
            }
            if(state === BidState.confirmed) {
                return {
                    de: 'Ihre Buchung war erfolgreich',
                    en: 'Booking successful',
                    es: 'Reservar aceptada',
                    fr: 'Réservation acceptée',
                    nl: 'Succesvol boeking',
                    it: 'Prenotazione è andata a buon fine',
                }
            }
            if(state === BidState.denied) {
                return {
                    de: 'Buchung fehlgeschlagen',
                    en: 'Booking rejected',
                    es: 'Reservar rechazada',
                    fr: 'Réservation rejetée',
                    nl: 'Boeking afgewezen',
                    it: 'Prenotazione fallita',
                }
            }
        }
        return {
            de: 'de: undefined BidState '+state,
            en: 'en: undefined BidState '+state,
            es: 'es: undefined BidState '+state,
            fr: 'fr: undefined BidState '+state,
            nl: 'nl: undefined BidState '+state,
            it: 'it: undefined BidState '+state,
        }
    },
}